<template>
  <div>
    <div class="trial__card-header">
      <div class="trial__card-title">
        <h3>
          <span>{{ typeTranslate[task.type] }}</span>
          <Tooltip>
            Есть два типа заданий: контент и тренажёр. Контент поможет получить знания, а тренажёр
            применть их на практике.
          </Tooltip>
        </h3>
        <strong>{{ task.content }}</strong>
      </div>
      <svg-icon :name="`tasks/${task.type}`" />
    </div>
    <span class="trial__card-body"> Задание {{ task.number }} </span>
    <div class="trial__card-footer">
      <button @click="$emit('start', task.id)">
        <svg-icon name="play" />
        Начать
      </button>
      <div>
        <Tooltip>
          Здесь отображается количество очков, которое ты заработааешь выполнив задание.
        </Tooltip>
        <span>{{ task.points }} очков</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '@/components/Common/Tooltip'

export default {
  name: 'Lesson',
  components: { Tooltip },
  props: {
    task: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    typeTranslate() {
      return {
        letters: 'Тренажёр',
        material: 'Образовательный материал',
        content: 'Контент',
        test: 'Тест'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.trial__card {
  &-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    & > svg {
      width: 56px;
      height: 56px;

      &::v-deep {
        .background {
          fill: $luchmara;

          &-stroke {
            stroke: $luchmara;
          }
        }

        .content {
          fill: $whisper;

          &-stroke {
            stroke: $whisper;
          }
        }
      }

      @include md-and-down {
        width: 48px;
        height: 48px;
      }
    }
  }

  &-title {
    display: flex;
    flex-direction: column;

    h3 {
      font-weight: 500;
      font-size: 15px;
      letter-spacing: 0.1px;
      color: $manatee;
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      span {
        display: block;
        margin-right: 8px;
      }
    }

    & > strong {
      font-weight: bold;
      font-size: 18px;
      letter-spacing: 0.1px;
      color: $deepdark;

      @include md-and-down {
        font-weight: 500;
        font-size: 15px;
      }
    }
  }

  &-footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    & > div {
      display: flex;
      align-items: center;
      margin-bottom: 2px;

      span {
        font-weight: 500;
        font-size: 24px;
        color: $luchmara;
        margin-left: 6px;
        display: block;

        @include md-and-down {
          font-size: 20px;
        }
      }
    }

    & > button {
      background: $luchmara;
      padding: 12px 16px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 22px;
      letter-spacing: 0.2px;
      color: $whisper;
      filter: drop-shadow(0 0 16px rgba($luchmara, 0.4));

      svg {
        width: 24px;
        height: 24px;
        margin-right: 16px;
        fill: $whisper;
      }

      @include md-and-down {
        padding: 10px 16px;
        font-size: 18px;

        svg {
          margin-right: 8px;
          width: 12px;
          height: 12px;
        }
      }

      @include md-and-up {
        &:hover {
          color: $white;
          background: rgba($luchmara, 0.7);

          svg {
            fill: $white;
          }
        }
      }
    }
  }

  &-body {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: $manatee;
    margin: 16px 0;
    display: block;

    @include md-and-down {
      margin: 30px 0;
    }
  }
}
</style>
